import { useCallback, useReducer, useState } from 'react'
import {
  ESTADO_QUALIDADE_INICIAL,
  nivelForcadoDaBusca,
  reduzirQualidade,
  type NivelQualidade,
} from './qualidadeGrafica'

export interface QualidadeAdaptativa {
  readonly nivel: NivelQualidade
  /** `false` quando o nível foi fixado por `?qualidade=` e o monitor não deve atuar. */
  readonly adaptativa: boolean
  readonly aoDecair: () => void
  readonly aoSubir: () => void
}

function lerNivelForcado(): NivelQualidade | null {
  if (typeof window === 'undefined') return null
  return nivelForcadoDaBusca(window.location.search)
}

/**
 * O estado vive no React, fora do `<Canvas>`, e não no store do R3F: o
 * `<Canvas dpr>` reaplica a prop a cada render, então um `setDpr` feito de
 * dentro seria desfeito no render seguinte. Quem manda no DPR é a prop.
 */
export function useQualidadeAdaptativa(): QualidadeAdaptativa {
  const [forcado] = useState(lerNivelForcado)
  const [estado, despachar] = useReducer(reduzirQualidade, ESTADO_QUALIDADE_INICIAL)

  const aoDecair = useCallback(() => despachar('decair'), [])
  const aoSubir = useCallback(() => despachar('subir'), [])

  return {
    nivel: forcado ?? estado.nivel,
    adaptativa: forcado === null,
    aoDecair,
    aoSubir,
  }
}
